module.exports = __webpack_public_path__ + "img/26.c265d51d.jpg";